export default class Equivalency {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    "acceptedProviders": [
      {
        "displayLink": "string",
        "hasExpirationDate": true,
        "hasIssuedDate": true,
        "maxFiles": 0,
        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        "optionalLink": "string",
        "optionalName": "string",
        "trainingProviderID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        "type": "FILE",
        "launchLink": "string"
      }
    ],
    "cardDescription": "string",
    "customerID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "detailedDescription": "string",
    "detailedName": "string",
    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "internalName": "string",
    "matches": [
      "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    ],
    "matchesElectiveCount": 0,
    "name": "string",
    "order": 0
  }
  */
  async createEquivalency(providerObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/customer/${this.api.config.customerID}/equivalence/new`;
    req.body = providerObj;
    return await req.exec();
  }
  async updateEquivalency(providerObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = `/customer/${this.api.config.customerID}/equivalence/${providerObj.id}`;
    req.body = providerObj;
    return await req.exec();
  }
  async deleteEquivalency(providerID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/customer/${this.api.config.customerID}/equivalence/${providerID}`;
    return await req.exec();
  }
  async getEquivalency(providerID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/customer/${this.api.config.customerID}/equivalence/${providerID}`;
    return await req.exec();
  }
  async getAllEquivalencies() {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/customer/${this.api.config.customerID}/equivalences`;
    return await req.exec();
  }
}
